import { restRequest } from 'core/utils/backend-service';
import { LocationsByUserResult } from 'core/contexts/locations/location.model';
import { LocationsByUserResultApi } from './location-by-user.api';
import { mapListedLocationFromApiToVm, toAccessState } from './locations.api.mapper';
import { LOCATIONS_BY_USER_REST_ENDPOINT } from './locations.constants';

export const getLocationsByUser = (): Promise<LocationsByUserResult> =>
    restRequest('GET', LOCATIONS_BY_USER_REST_ENDPOINT)
        .then((response) => response.json())
        .then((result: LocationsByUserResultApi) => ({
            locations: result.locations.map(mapListedLocationFromApiToVm),
            accessState: toAccessState(result.accessState),
        }));
